@if (graphLoaded) {
<div
	id="chart"
	style="width: 100%"
>
	<apx-chart
		#chart
		[series]="chartOptions.series"
		[chart]="chartOptions.chart"
		[colors]="chartOptions.colors"
		[stroke]="chartOptions.stroke"
		[xaxis]="chartOptions.xaxis"
		[yaxis]="chartOptions.yaxis"
		[grid]="chartOptions.grid"
		[title]="chartOptions.title"
		[dataLabels]="chartOptions.dataLabels"
		style="width: 100%"></apx-chart>
</div>
}
